export default __webpack_public_path__ + "static/media/ctaArrowSVG.6ef99bb2.svg";